import { createSelector } from 'reselect';
import { path, prop, pipe, map, propOr, mergeAll } from 'ramda';

const localState = path(['reports', 'patientsInfo']);

export const isPatientsInfoLoading = createSelector(
  localState,
  prop('loading'),
);

export const getPatientsInfo = createSelector(
  localState,
  prop('data'),
);

export const isPatientsInfo = createSelector(
  getPatientsInfo,
  data => !!data,
);

export const getPatientsDataForReportsList = createSelector(
  getPatientsInfo,
  pipe(
    propOr([], 'entry'),
    map(
      pipe(
        prop('resource'),
        resource => ({
          [prop('id')(resource)]: {
            lang: path(['communication', '0', 'language', 'text'])(resource),
            name: path(['name', '0', 'text'])(resource),
          },
        }),
      ),
    ),
    mergeAll,
  ),
);
